import { render, staticRenderFns } from "./cs-portal-config-general.vue?vue&type=template&id=49656120"
import script from "./cs-portal-config-general.vue?vue&type=script&lang=js"
export * from "./cs-portal-config-general.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports